var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScreenSahringImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.756,
    height: 23.343,
    viewBox: "0 0 30.756 23.343",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Screen",
    transform: "translate(66.783 -1896.86)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6280",
    "data-name": "Path 6280",
    d: "M-35.478,1942.377a.785.785,0,0,1,.785.785v.3c0,.556,0,.925-.5,1.111-.138.055-.315.086-4.6.086H-41.49l-1.767,0c-3.953-.006-4.366-.006-4.716-.394a.855.855,0,0,1-.174-.711c.006-.056.011-.109.011-.162v-.225a.785.785,0,0,1,.785-.785Z",
    transform: "translate(-10.007 -24.455)",
    fill: "#ff7452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6281",
    "data-name": "Path 6281",
    d: "M-36.253,1897.7a1.8,1.8,0,0,0-.62-.619l-.2-.119a.785.785,0,0,0-.395-.106h-27.85a.785.785,0,0,0-.412.117l-.238.147-.009.007a1.847,1.847,0,0,0-.6.642l-.111.206a.788.788,0,0,0-.093.371v16.589a.783.783,0,0,0,.111.4l.137.23a1.8,1.8,0,0,0,.652.651l.225.134a.783.783,0,0,0,.4.111h27.734a.788.788,0,0,0,.395-.106l.2-.117a1.968,1.968,0,0,0,.626-.595l.137-.2a.782.782,0,0,0,.137-.442v-16.7a.789.789,0,0,0-.106-.395Zm-10.939,8.14a.692.692,0,0,1-.141.4.7.7,0,0,1-.564.272h-.022a.782.782,0,0,1-.215-.03l-.007,0a4.11,4.11,0,0,1-.829-.715l-.684-.668c-.273-.244-.331-.244-.484-.244a.465.465,0,0,0-.471.308.714.714,0,0,0-.049.268l-.037,5.721-.013.023v.034l-.1.146a.7.7,0,0,1-.59.332h0a.7.7,0,0,1-.59-.332l-.1-.146v-.034l-.014-.023-.037-5.721a.718.718,0,0,0-.049-.267.465.465,0,0,0-.471-.308c-.152,0-.211,0-.483.244l-.684.668a4.12,4.12,0,0,1-.829.715l-.007,0a.782.782,0,0,1-.215.03H-54.9a.7.7,0,0,1-.565-.272.692.692,0,0,1-.14-.4c0-.009,0-.019,0-.029a.673.673,0,0,1,.026-.2s0-.008,0-.012,0-.013.008-.021l.005-.015.008-.011a19,19,0,0,1,1.759-1.87c.172-.172.335-.336.491-.49.6-.6,1.153-1.136,1.421-1.369l.074-.064a.675.675,0,0,1,.089-.065.387.387,0,0,1,.076-.038.611.611,0,0,1,.257-.029c.188,0,.228.006.314.059a.754.754,0,0,1,.093.068c.225.194.976.91,1.982,1.922a13.649,13.649,0,0,1,1.78,1.917.736.736,0,0,1,.022.12c0,.014,0,.028.005.041s0,.01,0,.016A.61.61,0,0,1-47.192,1905.844Z",
    transform: "translate(0 0)",
    fill: "#ff7452"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenSahringImg);
export default __webpack_public_path__ + "static/media/Screen-sahring-img.0582310e875fccea8fa65ce412154dc9.svg";
export { ForwardRef as ReactComponent };